import React from "react";
 import { Link } from "react-router-dom";
function BookingReportMenu() {
  

  return (

    <>
    <div className="container-fluid my-2 mb-3">
      <div className="text-start">
        <Link to="/booking-report" className="rptmenu1 me-2 p-1">Hotel Booking Report</Link>
        <Link  to="/agent/flight-report" className="rptmenu1 me-2 p-1">Flight Booking Report</Link>
        <Link to="/agent/bus-report" className="rptmenu1 me-2 p-1">Bus Booking Report</Link>
        <Link to="/agent/dth-report" className="rptmenu1 me-2 p-1">Recharge/DTH Report</Link>
      </div>
    </div>
    </>
    
  );
}

export default BookingReportMenu;
